module.exports = __webpack_public_path__ + "videos/beginners-series_homepage-tile.8dcac91.mp4";